/**
 * @description 页面逻辑基类
 * @author zhijie.huang
 * @date 2018/9/11
 */
import REQUEST_OPT from './request-opt.json'
import request from '../utils/request'
import errorCode from '@/lang/'
// import { Loading, Message } from '@ukx/uke-ui'
import { Loading, Message } from 'element-ui'

class LogicBase {
  constructor ({Auth , Debug}) {
    this.REQUEST_OPT = REQUEST_OPT
    this.ERROR_CODE = errorCode.t('errorCode')

    // 设置鉴权助手
    this.authHelper = Auth ? new Auth(this, this.ajax) : null;

    // 设置鉴权助手
    this.debugHelper = Debug ? new Debug(this, this.ajax) : null;

    // console.log('errorCode', this.ERROR_CODE);
  }

  //  暂不考虑多语言切换
  _getErrorText (code , TexT) {
    return this.ERROR_CODE[code] ? this.ERROR_CODE[code] : TexT;
  }

  _handleErrorTips (text) {
    Message({
      message: text,
      type: 'error'
    })
  }

  _fixData (data) {
    const res = {};
    for (const key in data) {
      if (typeof data[key] === 'object') {
        res[key] = {};
        for (const kk in data[key]){
          if (data[key][kk] !== '') res[key][kk] == data[key][kk]
        }
      } else {
        res[key] = data[key]
      }

    }
    return res
  }

  ajax (data, noTips = false, noLoading = false) {

    const resData = data;

    if (resData.auth && this.authHelper ) {
        return this.authHelper.ajaxAuthor(resData, noTips, noLoading)
    }

    if (resData.test && this.debugHelper) {
        return this.debugHelper.ajaxDebug(resData, noTips, noLoading)
    }

    let loading = noLoading ? null : Loading.service({ fullscreen: true })

    return new Promise((resolve, reject) => {
      if (resData.method.toLowerCase() === 'get') {
        resData.params = resData.data
        delete resData.data
      }

      request(resData).then((res) => {
        if (res) {
          if (this.authHelper.sessionCheck(res)) {
            const errorText = this._getErrorText(res.resultCode,res.resultDesc)
            if (!noTips) this._handleErrorTips(errorText)
            this.authHelper.handleSesstionTimeout()
          } else if (res.resultCode === '00000000') {
            resolve(res.data)
          } else {
            const errorText = this._getErrorText(res.resultCode,res.resultDesc)
            if (!noTips) this._handleErrorTips(errorText)
            reject(res)
          }
        }
      }).catch((err) => {
        reject(`${err.status} Error: ${err.statusText}`) // eslint-disable-line
      }).then(() => {
        if(!resData.data.loadingShow){
          loading ? loading.close() : false
        }
      })
          
    })
  }
}

export default LogicBase


// WEBPACK FOOTER //
// ./src/logic/logic.js